import client from './client';

export async function getCodeMasterList(params) {
  const res = await client.get('/admin/code/master', { params });
  return res.data;
}

export async function createCodeMaster(payload) {
  const res = await client.post('/admin/code/master', payload);
  return res.data;
}

export async function updateCodeMaster(masterCode, payload) {
  const res = await client.put(`/admin/code/master/${masterCode}`, payload);
  return res.data;
}

export async function deleteCodeMaster(masterCode) {
  const res = await client.delete(`/admin/code/master/${masterCode}`);
  return res.data;
}

export async function getCodeDetailList(masterCode) {
  const res = await client.get(`/admin/code/master/${masterCode}/detail`);
  return res.data;
}

export async function createCodeDetail(payload) {
  const res = await client.post('/admin/code/detail', payload);
  return res.data;
}

export async function updateCodeDetail(masterCode, detailCode, payload) {
  const res = await client.put(`/admin/code/detail/${masterCode}/${detailCode}`, payload);
  return res.data;
}

export async function deleteCodeDetail(masterCode, detailCode) {
  const res = await client.delete(`/admin/code/detail/${masterCode}/${detailCode}`);
  return res.data;
}
